import { MouseEvent } from 'react';

/**
 * Handles navigation with support for opening links in new tabs via:
 * - Cmd/Ctrl + Click
 * - Middle mouse button click
 * - Shift + Click
 * - Right-click (browser's native context menu)
 * 
 * @param event - The mouse event
 * @param url - The URL to navigate to
 * @param push - The history.push function from react-router
 * @param state - Optional state to pass to history.push
 */
export const handleNavigation = (
  event: MouseEvent,
  url: string,
  push: (path: string, state?: any) => void,
  state?: any
) => {
  // Check if user wants to open in new tab
  const shouldOpenInNewTab = 
    event.ctrlKey || // Ctrl+Click (Windows/Linux)
    event.metaKey || // Cmd+Click (Mac)
    event.button === 1 || // Middle mouse button
    event.shiftKey; // Shift+Click

  if (shouldOpenInNewTab) {
    event.preventDefault();
    window.open(url, '_blank');
  } else {
    // Normal navigation
    push(url, state);
  }
};

/**
 * Creates a navigation handler function with the given URL and push function
 * 
 * @param url - The URL to navigate to
 * @param push - The history.push function from react-router
 * @param state - Optional state to pass to history.push
 * @returns A click handler function
 */
export const createNavHandler = (
  url: string,
  push: (path: string, state?: any) => void,
  state?: any
) => {
  return (event: MouseEvent) => {
    handleNavigation(event, url, push, state);
  };
};

